module.exports = __webpack_public_path__ + "img/right.d4fb922c.png";